export const isAuthRoute = (url: string | undefined) =>
  !!url?.match(/\/auth(\/|$)/);
